import React, { useState } from 'react';
import { ChevronDown, ChevronUp, X } from 'lucide-react';

function FilterSection({ title, children, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border-b border-[#E5E5E5] pb-5 mb-5">
      <button
        className="flex items-center justify-between w-full mb-4"
        onClick={() => setOpen(o => !o)}
      >
        <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#0A0A0A] font-work">{title}</p>
        {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
      </button>
      {open && children}
    </div>
  );
}

const CATEGORIES = ['Bags', 'Shoes', 'Clothing', 'Accessories'];
const GENDERS = ['Women', 'Men', 'Unisex'];

export function ShopSidebar({
  filters, designers, selectedDesigners, activeFilterCount,
  total, updateFilter, clearFilters, toggleDesigner,
}) {
  return (
    <div className="w-64 flex-shrink-0">
      <div className="flex items-center justify-between mb-8">
        <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#0A0A0A] font-work">Filters</p>
        {activeFilterCount > 0 && (
          <button
            onClick={clearFilters}
            className="text-xs text-[#D4AF37] hover:text-[#0A0A0A] transition-colors font-work flex items-center gap-1"
          >
            <X size={12} /> Clear all
          </button>
        )}
      </div>

      <FilterSection title="Category">
        <div className="flex flex-col gap-2">
          {CATEGORIES.map(c => (
            <button
              key={c}
              onClick={() => updateFilter('category', filters.category === c ? '' : c)}
              className={`text-left text-sm font-work py-1 transition-colors ${filters.category === c ? 'text-[#D4AF37] font-semibold' : 'text-[#555555] hover:text-[#0A0A0A]'}`}
              data-testid={`filter-category-${c.toLowerCase()}`}
            >
              {c}
            </button>
          ))}
        </div>
      </FilterSection>

      <FilterSection title="Gender">
        <div className="flex flex-col gap-2">
          {GENDERS.map(g => (
            <button
              key={g}
              onClick={() => updateFilter('gender', filters.gender === g ? '' : g)}
              className={`text-left text-sm font-work py-1 transition-colors ${filters.gender === g ? 'text-[#D4AF37] font-semibold' : 'text-[#555555] hover:text-[#0A0A0A]'}`}
            >
              {g}
            </button>
          ))}
        </div>
      </FilterSection>

      <FilterSection title={`Designer${selectedDesigners.length ? ` (${selectedDesigners.length})` : ''}`}>
        {selectedDesigners.length > 0 && (
          <button
            onClick={() => updateFilter('designer', '')}
            className="text-[10px] text-[#D4AF37] hover:text-[#0A0A0A] font-work mb-3 transition-colors"
          >
            Clear {selectedDesigners.length} selected
          </button>
        )}
        <div className="flex flex-col gap-2.5 max-h-56 overflow-y-auto pr-1">
          {designers.map(d => {
            const checked = selectedDesigners.includes(d);
            return (
              <button
                key={d}
                onClick={() => toggleDesigner(d)}
                className="flex items-center gap-2.5 text-left py-0.5 transition-colors group"
                data-testid={`filter-designer-${d.replace(/\s+/g, '-').toLowerCase()}`}
              >
                <span className={`w-3.5 h-3.5 border flex-shrink-0 flex items-center justify-center transition-colors ${checked ? 'bg-[#D4AF37] border-[#D4AF37]' : 'border-[#CCCCCC] group-hover:border-[#D4AF37]'}`}>
                  {checked && (
                    <svg width="8" height="6" viewBox="0 0 8 6" fill="none">
                      <path d="M1 3L3 5L7 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                </span>
                <span className={`text-sm font-work ${checked ? 'text-[#D4AF37] font-semibold' : 'text-[#555555] group-hover:text-[#0A0A0A]'}`}>
                  {d}
                </span>
              </button>
            );
          })}
        </div>
      </FilterSection>

      <FilterSection title="Minimum Discount">
        <div className="flex flex-col gap-2">
          {[10, 20, 30, 40].map(d => (
            <button
              key={d}
              onClick={() => updateFilter('min_discount', filters.min_discount === String(d) ? '' : String(d))}
              className={`text-left text-sm font-work py-1 transition-colors ${filters.min_discount === String(d) ? 'text-[#D4AF37] font-semibold' : 'text-[#555555] hover:text-[#0A0A0A]'}`}
            >
              {d}%+ off
            </button>
          ))}
        </div>
      </FilterSection>
    </div>
  );
}
